import { experimentCodesWhitelist } from '../constants';

// util to test the split config for the `cvr_default_discount` experiment to validate the code.
export const isSplitDiscountConfigValid = (
  splitConfig: Record<string, unknown> | undefined
) => {
  const code = splitConfig?.code;
  return typeof code === 'string' ? experimentCodesWhitelist.has(code) : false;
};
